import { gql } from "@apollo/client"
import { SESSION_FRAGMENT } from "../../fragments"

const CREATE_SESSION_MUTATION = gql`
  ${SESSION_FRAGMENT}

  mutation($input: CreateSessionInput!) {
    createSession(input: $input) {
      ...SessionFields
    }
  }
`

export { CREATE_SESSION_MUTATION }